class UpdateUser {
	constructor(
		public readonly accountId: number,
		public readonly userId: number,
		public readonly firstName: string,
		public readonly lastName: string,
		public readonly email: string,
		public readonly roleId: number,
		public readonly organizationIds: readonly number[],
		public readonly facilityIds: readonly number[],
		// Bare value (`'password'` / `'sso'`), never the `{ value, label }` object read back on `UserView`.
		// The `PUT` is a full replacement: omitting this field is not "leave unchanged", it is a `400`.
		public readonly authenticationMode: string,
	) {
		Object.freeze(this);
	}

	// `accountId` and `userId` are route identifiers, never echoed in the body. The server only applies
	// `email` to a never-activated account and rejects a change on an activated one.
	toJSON(): Record<string, unknown> {
		return {
			firstName: this.firstName,
			lastName: this.lastName,
			email: this.email,
			roleId: this.roleId,
			organizationIds: this.organizationIds,
			facilityIds: this.facilityIds,
			authenticationMode: this.authenticationMode,
		};
	}
}

export default UpdateUser;
